import SchoolDescription from './SchoolDescription'


export default SchoolDescription
